import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import { RegDocFieldsForDocFormFragmentDoc } from '../../../fragments/regDocFieldsForDocForm.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetRegulatoryDocumentEditFormQueryVariables = Types.Exact<{
  regulatoryDocumentId: Types.Scalars['ID'];
}>;


export type GetRegulatoryDocumentEditFormQuery = { __typename?: 'Query', regulatoryDocument?: { __typename?: 'RegulatoryDocument', id: string, summary?: string | null, origin: Types.Origin, getexLink?: string | null, regulation?: { __typename?: 'Regulation', id: string, name: string, regulationNumber: string, isMachineRegulation: boolean } | null, topicManagementSummary?: { __typename?: 'TopicManagementSummary', quarter: Types.TopicManagementSummaryQuarter, year: number } | null, predecessor?: { __typename?: 'RegulatoryDocument', id: string, name: string } | null, successor?: { __typename?: 'RegulatoryDocument', id: string, name: string } | null, documentSource?: { __typename?: 'DocumentSource', id: string, name: string } | null, document?: { __typename?: 'BlobRef', uri: any, contentType: string, fileName: string } | null, documentReferences?: Array<{ __typename?: 'DocumentReference', referenceDocumentType?: string | null, reference?: { __typename?: 'Reference', id: string, name: string } | null, documentReferenceGroup: { __typename?: 'ReferenceGroup', selectAllRegulatoryDocuments: boolean, regulationReference?: { __typename?: 'Regulation', id: string, name: string, regulationNumber: string } | null, regulatoryDocumentReferences?: Array<{ __typename?: 'RegulatoryDocument', id: string, name: string } | null> | null }, referencedByDocuments: Array<{ __typename?: 'RegulatoryDocument', id: string, name: string, regulation?: { __typename?: 'Regulation', id: string, regulationNumber: string } | null }> }> | null, attachments?: Array<{ __typename?: 'AttachmentRef', attachmentId: string, isVkoOnly?: boolean | null, file: { __typename?: 'BlobRef', uri: any, contentType: string, fileName: string, originalFileName?: string | null }, category?: { __typename?: 'AttachmentCategory', id: string, name: string } | null }> | null } | null };


export const GetRegulatoryDocumentEditFormDocument = gql`
    query GetRegulatoryDocumentEditForm($regulatoryDocumentId: ID!) {
  regulatoryDocument(id: $regulatoryDocumentId) {
    id
    ...RegDocFieldsForDocForm
    summary
    origin
    getexLink
    regulation {
      id
      name
      regulationNumber
      isMachineRegulation
    }
  }
}
    ${RegDocFieldsForDocFormFragmentDoc}`;

/**
 * __useGetRegulatoryDocumentEditFormQuery__
 *
 * To run a query within a React component, call `useGetRegulatoryDocumentEditFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegulatoryDocumentEditFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegulatoryDocumentEditFormQuery({
 *   variables: {
 *      regulatoryDocumentId: // value for 'regulatoryDocumentId'
 *   },
 * });
 */
export function useGetRegulatoryDocumentEditFormQuery(baseOptions: Apollo.QueryHookOptions<GetRegulatoryDocumentEditFormQuery, GetRegulatoryDocumentEditFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegulatoryDocumentEditFormQuery, GetRegulatoryDocumentEditFormQueryVariables>(GetRegulatoryDocumentEditFormDocument, options);
      }
export function useGetRegulatoryDocumentEditFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegulatoryDocumentEditFormQuery, GetRegulatoryDocumentEditFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegulatoryDocumentEditFormQuery, GetRegulatoryDocumentEditFormQueryVariables>(GetRegulatoryDocumentEditFormDocument, options);
        }
export type GetRegulatoryDocumentEditFormQueryHookResult = ReturnType<typeof useGetRegulatoryDocumentEditFormQuery>;
export type GetRegulatoryDocumentEditFormLazyQueryHookResult = ReturnType<typeof useGetRegulatoryDocumentEditFormLazyQuery>;
export type GetRegulatoryDocumentEditFormQueryResult = Apollo.QueryResult<GetRegulatoryDocumentEditFormQuery, GetRegulatoryDocumentEditFormQueryVariables>;